import React from 'react';
import Landing from "./web";
import {BrowserRouter as Router} from 'react-router-dom';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { DPIconAlertToast, DPIconCloseToast } from 'assets/icons';


function App() {
    return (
        <div className="App">
            <Router>
                <Landing/>
            </Router>

            <Toaster
              toastOptions={{
                duration: 6000,
                success: {
                  background: '#15CF74',
                  color: 'white',
                  zIndex: 1000000
                },
                error: {
                  style: {
                    background: '#EF3C2E',
                    color: 'white',
                    zIndex: 1000000
                  },
                  icon: <DPIconAlertToast style={{ width: '1.2rem', height: '1.2rem' }} />,
                },
                style: {
                  borderRadius: '3px',
                },
              }}
            >
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <>
                      {icon}
                      {message}
                      {t.type !== 'loading' && (
                        <span style={{ cursor: 'pointer' }} role="presentation" onClick={() => toast.dismiss(t.id)}>
                          <DPIconCloseToast style={{ width: '0.8rem', height: '0.8rem' }} />
                        </span>
                      )}
                    </>
                  )}
                </ToastBar>
              )}
            </Toaster>
        </div>
    );
}

export default App;
